/**
 * EtInleverDialoog — bevestiging vóór inleveren (Facet-blauwdruk §10 punt 1).
 *
 * Het echte examen vraagt om bevestiging en zegt erbij hoeveel vragen nog
 * onbeantwoord zijn; daarna kun je niet meer terug. Eigen teksten, tw-stijl.
 */
import React, { useEffect, useRef } from 'react';
import { QvButton, QvIcon } from '../../pages/QuestionView';
import './EtInleverDialoog.css';

export default function EtInleverDialoog({ open, aantalOnbeantwoord, onTerug, onInleveren }) {
  const ref = useRef(null);
  useEffect(() => { if (open && ref.current) ref.current.focus(); }, [open]);
  if (!open) return null;

  return (
    <div className="etd-achtergrond" role="presentation" onClick={onTerug}>
      <div ref={ref} tabIndex={-1} className="etd-dialoog" role="alertdialog" aria-modal="true"
        aria-labelledby="etd-titel" onClick={(e) => e.stopPropagation()}>
        <h2 id="etd-titel">Ben je klaar?</h2>
        {aantalOnbeantwoord > 0 ? (
          <p className="etd-waarschuwing">
            Je hebt nog <b>{aantalOnbeantwoord} {aantalOnbeantwoord === 1 ? 'vraag' : 'vragen'}</b> niet gemaakt.
          </p>
        ) : (
          <p>Je hebt alle vragen gemaakt.</p>
        )}
        <p>Als je inlevert, kun je je antwoorden niet meer veranderen. Je ziet daarna je resultaat en het antwoordmodel per vraag.</p>
        <div className="etd-knoppen">
          <QvButton variant="secondary" onClick={onTerug} ariaLabel="Terug naar de vragen">
            <QvIcon name="arrow-left" size={16} stroke={2} /> Terug
          </QvButton>
          <QvButton variant="submit" onClick={onInleveren} ariaLabel="Definitief inleveren">
            Inleveren <QvIcon name="check" size={16} stroke={2.25} />
          </QvButton>
        </div>
      </div>
    </div>
  );
}
